<template>
  <!-- CPAPメニュー -->
  <div id="CpapMenu">
    <div id="container-center">
      <div class="title is-3">CPAP処方・配送サービス</div>
      <div class="cogrid-area">
        <div class="grid-container">
          <ul class="tile-container">
            <li v-if="!cpapDealerRentalFlg">
              <div class="contents">
                <router-link :to="{name:'CpapRequest', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-playlist-edit mdi-48px"  style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">新規処方申込み</div>
                </router-link>
              </div>
            </li>
            <li v-if="!cpapDealerRentalFlg && (isHospital || isDealer)">
              <div class="contents" style="position: relative;">
                <router-link :to="{name:'CpapRequestDraftView', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-content-save-edit-outline mdi-48px" style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">
                    保存中<br/>（処方一覧）
                  </div>
                </router-link>
                <span v-show="CpapTempPrescriptionCount > 0" class="notification-badge">{{ CpapTempPrescriptionCount }}</span>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link :to="{name:'CpapPatientList', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-account-multiple mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">処方変更・中止等申込み<br/><span style="font-size: 13px;">(既存患者への処方)</span></div>
                </router-link>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link :to="{name:'CpapRequestList', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-format-list-bulleted mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">CPAP処方申込<br/>履歴</div>
                </router-link>
              </div>
            </li>
            <!-- <li> -->
            <!-- 預託処方変更のデグレ改修20240326 -->
            <li v-if="!cpapDealerRentalFlg && userInfo.cpapDepositUseFlg">
              <div class="contents">
                <router-link :to="{name:'CpapRequestMenu', params:{instrument:true}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-book-edit mdi-48px"  style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">預託機処方<br/>申込み</div>
                </router-link>
              </div>
            </li>
            <!--
            <li>
              <div class="contents">
                <a v-on:click="openModal">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-book-edit mdi-48px"  style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">預託機申込み<br/><span style="font-size: 13px;" class="outline">※別途預託の契約要</span></div>
                </a>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link :to="{name:'CpapInstrumentList', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-devices mdi-48px"  style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">預託機器一覧<br/><span style="font-size: 13px;" class="outline">※別途預託の契約要</span></div>
                </router-link>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link :to="{name:'CpapTempInstalledRequest', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-home-account mdi-48px"  style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">デモ申込み</div>
                </router-link>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link :to="{name:'CpapRequest', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;" >
                    <i class="mdi mdi-playlist-edit mdi-48px"  style="position: relative;" ></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">試用申込み</div>
                </router-link>
              </div>
            </li>
            -->
            <!-- 運用が明確に決まっていない為非表示とする 20230825 -->
            <!-- <li v-if="!cpapUsageDetailBehalf">
              <div class="contents">
                <router-link :to="{name:'CpapUsedList', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-playlist-check mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">使用明細</div>
                </router-link>
              </div>
            </li> -->
            <li>
              <div class="contents">
                <router-link :to="{name:'CpapDefaultSettingList', params:{}}">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-application-settings mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">デフォルト値<br/>設定</div>
                </router-link>
              </div>
            </li>
            <li>
              <div class="contents">
                <router-link to="/guest/home">
                  <span class="icon" style="color: #fff; height: 45px;">
                    <i class="mdi mdi-keyboard-return mdi-48px" style="position: relative;"></i>
                  </span>
                  <div style="font-size: 18px; color: #fff;">サービス一覧に戻る</div>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <b-modal :active.sync="cpapRequestComfirm" @close="closeModal" has-modal-card>
      <cpapRequestComfirm-modal></cpapRequestComfirm-modal>
    </b-modal>
  </div>
</template>

<script>
import { role } from "@/components/mock/base/const.js";
const cpapRequestComfirmForm = {
  props: [],
  data() {
    return {};
  },
  methods: {
    inputAnswerYes: function(event) {
      this.$router.push({ 
        name: "CpapInstrumentRequest",
        params: {} });
      this.$parent.close();
    },
    inputAnswerNo: function(event) {
      this.$parent.close();
    }
  },
  template: `
        <div class="modal-card" style="width: 500px;">
          <header class="modal-card-head">
              <p class="modal-card-title" style="color: whitesmoke;">申込み確認</p>
          </header>
          <section class="modal-card-body" style="border: 1px solid #dbdbdb;">
            <div>
              <p>別途、預託契約の締結が必要です。<br>
              預託契約が完了していない場合は、申込みできません。</p>
            </div>
          </section>
          <footer class="modal-card-foot">
            <div>
            <b-button
              class="button is-primary is-inverted has-text-centered"
              type="button"
              v-on:click="inputAnswerYes"
            >
            OK
            </b-button>
            <b-button
              class="button is-light is-inverted has-text-centered"
              v-on:click="inputAnswerNo"
            >キャンセル</b-button>
            </div>
          </footer>
        </div>
      `
};

export default {
  name: "CpapMenu",
  methods: {
    closeModal: function(event) {
      this.cpapRequestComfirm = false;
    },
    openModal: function() {
      this.cpapRequestComfirm = true;
    },
    countCpapRequestDraft() {
      const THIS = this;
      var body = { belongsId: this.belongsId };
      this.apiCall(
        (client) => {
          return client.apis.externalCpap.countCpapRequestDraft({
            body: body,
          });
        },
        (result) => {
          THIS.CpapTempPrescriptionCount = result.obj.count;
        },
        (error) => {}
      );
    },
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      cpapRequestComfirm: false,
      cpapDealerRentalFlg:userInfo.cpapDealerRentalFlg,
      cpapUsageDetailBehalf: userInfo.cpapUsageDetailBehalf,
      userInfo,
      CpapTempPrescriptionCount: 0,
      belongsId: userInfo.belongsId,
      isHospital: userInfo.roleId == role.role_hospital,
      isDealer: userInfo.roleId == role.role_dealer,
    };
  },
  components: {
    "cpapRequestComfirm-modal":cpapRequestComfirmForm
  },
  mounted() {
    this.countCpapRequestDraft();
  }
};
</script>

<style lang="scss" >
.service-list {
  width: 100%;
}
.grid-area {
  display: grid;
  width: 900px;
  margin: 0 auto;
}
.grid-container {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-template-rows: 150px 1fr 100px;
  height: 100vh;
}

/*デザイン設定*/
.tile-container {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.tile-container > li {
  height: 150px;
  width: 150px;
  padding: 5px;
  background: linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  background: -moz-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  background: -webkit-linear-gradient(
      -35deg,
      rgb(0, 114, 218) 0%,
      rgb(110, 173, 243) 100%
  );
  display: table-cell;
  text-align: center;
}
.contents {
  display: table-cell;
  height: 150px;
  width: 150px;
  text-align: center;
  vertical-align: middle;
}

/*グリッド設定*/
.tile-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}
.subtext {
  font-size: 12px;
}
.outline {
  display        : inline-block;
  color          : red;            /* 文字の色 */
  letter-spacing : 1px;                /* 文字間 */
  font-weight    : bold; 
  text-shadow    : 
       1px  1px 0px white,
      -1px  1px 0px white,
       1px -1px 0px white,
      -1px -1px 0px white,
       1px  0px 0px white,
       0px  1px 0px white,
      -1px  0px 0px white,
       0px -1px 0px white;        /* 文字の影 */
}
.cogrid-area {
  display: grid;
  width: 700px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapMenu.vue